import { Api } from "queries/types";
import { useQuery } from "react-query";
import { get } from "./http";

const useDocumentsIndex = () => useQuery<Api.Document[]>(["documents"], () => get("/documents"));

export { useDocumentsIndex };
